import React, { FC } from "react";
import MaterialFormControlLabel, { FormControlLabelProps } from "@mui/material/FormControlLabel";

export const FormControlLabel: FC<FormControlLabelProps> = (props) => <MaterialFormControlLabel {...(props as any)} />;
